export default __webpack_public_path__ + "static/media/62.770a76e2.jpg";